import React, { useState } from 'react';
import _ from 'lodash';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';

import { ArrowRightUpIn, ArrowRightUpOut, PopBox } from '../customStyles/box';
import { DownloadIcon } from '../customStyles/images';
import theme from '../../theme';


const PoperButton = (props) => {
  const { iconLoading, fetchDownloadData } = props;
  const [target, setTarget] = useState(null);
  const isOpen = Boolean(target);

  const handleMenuOpen = (e) => {
    setTarget(e.currentTarget);
  };

  const handleMenuClose = () => {
    setTarget(null);
  };

  const handleDownload = () => {
    setTarget(null);
    fetchDownloadData();
  }

  return (
    <>
      <Button
        variant='fill-white'
        onClick={handleMenuOpen}
      // disabled
      >
        <DownloadIcon />

        <Typography
          sx={{
            display: {
              md: 'inline-block',
              xs: 'none'
            },
          }}
        >
          下載
        </Typography>
      </Button>

      <Popper
        open={isOpen}
        anchorEl={target}
        placement='bottom-end'
        style={{
          zIndex: 1000,
        }}
      >
        <ClickAwayListener onClickAway={handleMenuClose}>
          <Stack
            sx={{
              flexDirection: 'column',
              alignItems: "end",
              marginTop: '14px',
            }}
          >
            <Stack
              variant="end-center"
              sx={{
                position: 'relative',
                top: '-14px',
                right: { xs: '1000px', md: '0px' },
              }}>
              <ArrowRightUpIn />
              <ArrowRightUpOut />
            </Stack>

            <PopBox>
              {/* <Typography variant='body_sm' color='grey'>選擇資料範圍</Typography>

              <Divider sx={{ mt: 1.5, mb: 1 }} /> */}

              <Button
                fullWidth
                size="medium"
                variant="text-grey-normal"
                endIcon={iconLoading === 'data' ? <CircularProgress size={16} color="inherit" /> : null}
                disabled={iconLoading === 'data'}
                onClick={handleDownload}
                sx={{ padding: iconLoading === 'data' ? '6px 0 6px 16px' : '6px 16px' }}
              >
                使用者清單
              </Button>
            </PopBox>

          </Stack>
        </ClickAwayListener>
      </Popper>
    </>
  )

}

export default PoperButton;